cafm.rb.att = {

    getRoomBookingAttendees: function() {

        var roomBooking = cafm.views.getMainFormViewModel();

        if (!roomBooking.Attendees) {

            roomBooking.set('Attendees', []);
        }

        var list = isFunc(roomBooking.Attendees.toJSON) ? roomBooking.Attendees.toJSON() : roomBooking.Attendees;

        return cafm.util.where(list, function (att) {

            return !cafm.util.isTrue(att.IsDeleted);
        });
    },
    getRoomBookingAttendee: function (id) {

        var roomBooking = cafm.views.getMainFormViewModel();

        var attOnBooking = cafm.util.find(roomBooking.Attendees, function (att) {

            return att.ID == id;
        });

        return attOnBooking;
    },
    getRoomBookingAttendeeMatch: function (attendee) {

        var roomBooking = cafm.views.getMainFormViewModel();

        var attOnBooking = cafm.util.find(roomBooking.Attendees, function (att) {

            return att.PersonID && att.PersonID == attendee.PersonID && !att.IsDeleted;
        });

        // if there's no match check full name (we do this separately to offer some support for same name attendees (person ID is unique ID)
        if (isNullOrUndefined(attOnBooking)) {

            attOnBooking = cafm.util.find(roomBooking.Attendees, function (att) {

                return att.FullName == attendee.FullName && !att.IsDeleted;
            });
        }

        return attOnBooking
    },
    handlers: {

        addAttendee: function (e) {

            var attendeePersonId = $('#attendeeName [data-role="lookupValue"]').val();
            var roomBooking = cafm.views.getMainFormViewModel();
            var newAttendee = {};
                        
            if (cafm.util.guidHasValue(attendeePersonId)) {

                cafm.actions.execute({

                    url: cafm.url.api('Person/GetPerson/{0}', attendeePersonId),
                    method: 'GET',
                    statusCodeFuncs: {

                        200: function (person) {

                            $.extend(newAttendee, person);
                            newAttendee.PersonID = attendeePersonId;
                            newAttendee.Company = cafm.auth.companyName();
                            cafm.rb.att.helpers.addAttendee(newAttendee);
                        }
                    }
                });
            }
            else if(cafm.util.hasStringVal(roomBooking.AttendeeName)) {

                var attName = roomBooking.AttendeeName.trim();

                if (attName) {

                    newAttendee.FullName = attName;

                    if (attName.indexOf(' ') > -1) {

                        var names = attName.split(' ');
                        newAttendee.FirstName = names[0];
                        newAttendee.LastName = names[1];
                    }
                    else {

                        newAttendee.LastName = attName;
                    }

                    cafm.rb.att.helpers.addAttendee(newAttendee);
                }
            }

            setTimeout(function () {
                roomBooking.set('AttendeeName', null);
                roomBooking.set('AttendeePersonId', null);
            }, 500);
        },
        addAttendeeLookupSelected: function (item) {

            var personId = item.value;

            if (cafm.util.guidHasValue(personId)) {

                cafm.rb.att.handlers.addAttendee();
            }
        },
        edit: {

            ok: function () {

                var attendee = cafm.views.getActionWindowViewModel();
                var attOnBooking = cafm.rb.att.getRoomBookingAttendee(attendee.ID);

                if (cafm.views.validateActionForm()) {

                    var fullName = [];

                    // set full name if there's a last name
                    if (attendee.FirstName) {

                        fullName.push(attendee.FirstName);
                    }

                    // set full name if there's a last name
                    if (attendee.LastName) {

                        if (attendee.FirstName) {

                            fullName.push(' ');
                        }

                        fullName.push(attendee.LastName);
                    }

                    if (fullName.length) {

                        attendee.set('FullName', fullName.join(''));
                    }

                    // merge the attendee
                    attOnBooking.set(attendee.toJSON());

                    // refresh the attendees
                    cafm.rb.att.helpers.refreshAttendees();

                    // close the action window
                    cafm.views.closeActionWindow();
                }

            },
            cancel: cafm.toolbar.standardActionToolbar.cancel
        },
        editAttendee: function (args) {

            var tr = $(args.currentTarget).parents('tr:first');
            var grid = $('#attendeeGrid').getGrid().data('kendoGrid');

            if (grid) {

                var att = grid.dataItem(tr);

                if (att) {

                    var theUrl;
                    if (att.PersonID) {

                        theUrl = cafm.url.get('RoomBooking/EditAttendee/{0}', att.PersonID);
                    }
                    else {

                        theUrl = cafm.url.get('RoomBooking/EditAttendee');
                    }

                    cafm.views.openActionWindow({
                        url: theUrl,
                        method: 'GET',
                        isForm: true,
                        viewModel: att.toJSON(),
                        winOptions: {
                            width: 560,
                            height: 300
                        }
                    });
                }
            }
        },
        gridItemDataBound: function (args) {

            var rb = cafm.views.getMainFormViewModel();

            if (!rb.IsReadOnly) {

                args.sender.element.off('click.cafm').on('click.cafm', '.removeLink', cafm.rb.att.handlers.removeAttendee);
                args.sender.element.on('click.cafm', '.editLink', cafm.rb.att.handlers.editAttendee);

                cafm.rb.att.helpers.toggleNotifyAttendeesCheckbox(args.sender.dataSource.total() > 0);
            }
        },
        removeAttendee: function (args) {
            
            var tr = $(args.currentTarget).parents('tr:first');
            var grid = $('#attendeeGrid').getGrid().data('kendoGrid');

            if (grid) {

                var att = grid.dataItem(tr);

                if (att) {

                    cafm.rb.att.helpers.removeAttendee(att);
                }
            }
        }
    },
    helpers: {

        addAttendee: function (attendee) {

            var roomBooking = cafm.views.getMainFormViewModel();

            var exists = !isNullOrUndefined(cafm.rb.att.getRoomBookingAttendeeMatch(attendee));

            if (!exists) {

                cafm.actions.execute({

                    url: cafm.url.api('RoomBooking/AddClientAttendee'),
                    values: attendee,
                    statusCodeFuncs: {

                        200: function (res) {

                            if (!roomBooking.Attendees) {

                                roomBooking.Attendees = [];
                            }

                            roomBooking.Attendees.push(res);

                            // refresh the attendees
                            cafm.rb.att.helpers.refreshAttendees();
                        }
                    }
                });
            }
        },
        refreshAttendees: function () {

            $('#attendeeGrid').refreshGridDataSource();

            // refresh clashes
            cafm.rb.form.helpers.showClashesIfAny();
        },
        removeAttendee: function (attendee) {

            var attOnBooking = cafm.rb.att.getRoomBookingAttendee(attendee.ID);

            if (attOnBooking) {

                attOnBooking.set('IsDeleted', true);
            }

            // refresh attendees
            cafm.rb.att.helpers.refreshAttendees();
        },
        toggleNotifyAttendeesCheckbox: function (show) {

            if (show) {

                $('#sendEmailToAttendees').show();
            }
            else {

                // set SendEmailToAttendeesWhenProvisionalCreated to false as otherwise this flag will still be set to true on the server
                var roomBooking = cafm.views.getMainFormViewModel();
                roomBooking.set('SendEmailToAttendeesWhenProvisionalCreated', false);

                $('#sendEmailToAttendees').hide();
            }
        }
    }
}